export default {
    routerName: '登录',
    user: {
        loginName: '账号',
        password: '密码',
        captcha: '验证码',
    },
};
